<template>
  <div>
      <div class="row">
          <div class="col-12 col-md-10">
              <page-title title_text="زیرمجموعه ها" icon="marketing">
              </page-title>
          </div>
          <div class="col-12 col-md-2 my-1">
              <div>
                  <router-link class="kt-nav__link btn btn-primary float-right" to="/marketing/subsets-settlements">
                      {{ $t('marketing.dashboard.subset_settlements') }}
                  </router-link>
              </div>
          </div>
      </div>

    <div class="bg-white shadow-sm p-3 my-3" style="border-radius: 10px;">
      <div class="row">
        <div class="col-sm my-2">
          <input class="form-control" placeholder="نام زیرمجموعه" v-model="filter_name">
        </div>
        <div class="col-sm my-2">
          <div class="form-group my-0">
            <datePicker
                color="#00c1a4"
                format="YYYY-MM-DD HH:mm:ss"
                display-format="dddd jDD jMMMM jYYYY HH:mm"
                input-class="form-control"
                name="filter_from_date"
                placeholder="از تاریخ"
                clearable
                v-model="filter_from_date"
                type="datetime"/>
          </div>
        </div>
        <div class="col-sm my-2">
          <div class="form-group my-0">
            <datePicker
                color="#00c1a4"
                format="YYYY-MM-DD HH:mm:ss"
                display-format="dddd jDD jMMMM jYYYY HH:mm"
                input-class="form-control"
                name="filter_from_date"
                placeholder="تا تاریخ"
                clearable
                v-model="filter_to_date"
                type="datetime"/>
          </div>
        </div>
        <div class="col-sm my-2">
          <div>
            <button :class="query ? 'btn btn-success mr-2' : 'btn btn-success btn-block'" style="border-radius: 10px;"
                    @click="get_data(marketings.first_page_url)">اعمال فیلتر
            </button>
            <button class="btn btn-danger mr-3" style="border-radius: 10px;"
                    @click="reset_and_get" v-if="query">حذف فیلتر
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="is_init" class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px;">

      <div class="px-3">
        <div class="table-responsive">
          <table class="table  table-responsive table-borderless text-center" v-if="marketings.data.length > 0">
            <thead>
            <tr>
              <th scope="col" style="background-color: #eee;  border-radius: 0 16px 16px 0;">شناسه</th>
              <th scope="col" style="background-color: #eee;">نام زیرمجموعه</th>
              <th scope="col" style="background-color: #eee; ">
                کارمزد همکاری در فروش
              </th>
              <th scope="col" style="background-color: #eee; cursor: pointer;" @click="sortBy('created_at')">
                <span class="mx-2">تاریخ عضویت</span>
                <span v-if="sort_field == 'created_at'">
                  <span v-if="sort_sort == 'asc'">
                    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="#00bea5"><path
                        d="M0 0h24v24H0V0z" fill="none"/><path
                        d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"/></svg>
                  </span>
                  <span v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="#00bea5"><path
                        d="M0 0h24v24H0V0z" fill="none"/><path
                        d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"/></svg>
                  </span>
                </span>
              </th>
              <th scope="col" style="background-color: #eee;">میزان سود</th>
              <th scope="col" style="background-color: #eee;border-radius:16px 0 0 16px ;">عملیات ها</th>
            </tr>

            </thead>
            <tbody>
            <tr v-for="(marketing, index) in marketings.data" :key="index">
              <td class="en_num">{{ marketing.hashid }}</td>
              <td>{{ marketing.full_name }}</td>
              <td>{{ marketing.subset_profit_percent }}</td>
              <td v-text="toPersianDateFormat(marketing.created_at)"></td>
              <td>{{ marketing.subset_profit_amount }}</td>
              <td>
                  <div>
                      <router-link v-if="$can('read', 'marketing')" :to="marketing.hashid+'/actions'" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                          <i class="fa fa-eye"></i>
                      </router-link>
                      <router-link v-if="marketing.appR == true"
                                   :to="marketing.hashid+'/subset-app-transactions-report'"
                                   class="btn btn-sm btn-clean btn-icon btn-icon-sm"
                                   :title="$t('marketing.dashboard.subset_app_transactions_report')"
                      >
                          <i class="fa fa-dollar-sign"></i>
                      </router-link>
                      <router-link v-if="marketing.pspR == true" :to="marketing.hashid+'/subset-psp-transactions-report'"
                                   class="btn btn-sm btn-clean btn-icon btn-icon-sm"
                                   :title="$t('marketing.dashboard.subset_psp_transactions_report')"
                      >
                          <i class="fa fa-cubes"></i>
                      </router-link>
                  </div>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="empty-table" style="height: 300px" v-else>
            <table class="table table-responsive table-borderless text-center">
              <thead>
              <tr>
                <th scope="col" style="background-color: #eee;  border-radius: 0 16px 16px 0;">شناسه</th>
                <th scope="col" style="background-color: #eee;">نام زیرمجموعه</th>
                <th scope="col" style="background-color: #eee;">کارمزد همکاری در فروش</th>
                <th scope="col" style="background-color: #eee;">میزان سود</th>
                <th scope="col" style="background-color: #eee;border-radius:16px 0 0 16px ;">عملیات ها</th>
              </tr>
              </thead>
            </table>
            <div class="not-found" style="margin: 0 auto;">
              <img src="@/assets/new/image/not-found_new.png" width="200">
            </div>
          </div>
        </div>
      </div>

      <hr v-if="marketings.next_page_url || marketings.prev_page_url">

      <pagination :data="marketings" :get_data="get_data" :perpage="perpage"></pagination>
    </div>

    <div id="overlay" v-if="status == 'loading'">
      <div class="p-3" style="position: absolute;
  top: 50%;
  left: 50%;
  color: gray;
  background-color: white;
">


        <div class="spinner-border text-success" role="status">
        </div>
        <span>
          لطفا صبر کنید
        </span>


      </div>

    </div>
      <p class="font-weight-bold">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#F19E39"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
          <span>
              آمار نشان داده شده تا روز قبل محاسبه شده است.
              </span>
      </p>
  </div>
</template>

<script>
import {ApiService} from "@/common/api.service";
import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import Pagination from "@/components/main/pagination";
import PageTitle from "@/components/main/components/pageTitle";


export default {
  components: {PageTitle, Pagination},
  data() {
    return {
      perpage: {
        value: 15,
      },
      is_init: false,
      status: 'loading',
      marketings: null,
      filter_name: null,
      filter_from_date: null,
      filter_to_date: null,
      sort_field: null,
      sort_sort: 'desc',
    }
  },
  computed: {
    query() {
      let res = '';
      if (this.filter_name != null) {
        res = res + '&query[full_name]=' + this.filter_name;
      }
      if (this.filter_from_date != null) {
        res = res + '&query[from_date]=' + this.filter_from_date;
      }
      if (this.filter_to_date != null) {
        res = res + '&query[to_date]=' + this.filter_to_date;
      }
      if (this.sort_field != null) {
        res = res + '&sort[field]=' + this.sort_field + '&sort[sort]=' + this.sort_sort;
      }

      return res;
    }
  },
  methods: {
    toPersianDateFormat(val) {
      if (val == undefined || val == null || val == '') {
        return '';
      }

      val = String(val);

      return val.replace(/\-/g, "/");
    },
    sortBy(field) {
      this.sort_field = String(field);

      if (this.sort_sort == 'desc') {
        this.sort_sort = 'asc';
      } else {
        this.sort_sort = 'desc';
      }

      this.get_data(this.marketings.path + '?page=1');
    },
    resetQuery() {
      this.filter_name = null;

      this.filter_from_date = null;
      this.filter_to_date = null;
    },
    get_data(url, callback = () => {
    }) {
      this.status = 'loading'
      ApiService.query(url + this.query + '&perpage=' + this.perpage.value)
          .then(json => {
            this.marketings = json.data.data;
            this.status = 'ok'
            callback();
          })
    },
    reset_and_get() {
      this.resetQuery();
      this.get_data(this.marketings.path + '?page=1');
    }
  },
  mounted() {
    ApiService.get('marketing/subsets', '').then(json => {
      this.marketings = json.data.data;
      this.is_init = true;
      this.status = 'ok';
      setTimeout(function () {
        $('.kt-selectpicker').selectpicker({
          size: 4,
          liveSearch: true,
          noneResultsText: i18n.t('selectpicker.none_result'),
          selectAllText: i18n.t('selectpicker.select_all'),
          noneSelectedText: i18n.t('selectpicker.nothing_selected')
        })
      }, 1000);
    });
  }
}
</script>

<style>
#overlay {
  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 1000; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
</style>
